import { Pipe, PipeTransform } from '@angular/core';
import { StaticMessage } from '@shared/enums';
import { getStaticMessage } from '@shared/utils';

@Pipe({ name: 'copyFromPrevDprTooltip' })
export class CopyFromPrevDprTooltipPipe implements PipeTransform {
  transform(
    canCopy: boolean,
    isFirstDpr: boolean,
    editRights: boolean,
    appOnline: boolean,
    enableCopyDprDataFromPreviousDpr: boolean,
    isDprLocked: boolean
  ): string {
    if (!enableCopyDprDataFromPreviousDpr) {
      return getStaticMessage(StaticMessage.CopyFromPrevDprNotEnabledTooltip);
    }

    if (!editRights) {
      return getStaticMessage(StaticMessage.NoEditRightsTooltip);
    }

    if (isFirstDpr) {
      return getStaticMessage(StaticMessage.CanNotCopyFirstDprTooltip);
    }

    if (isDprLocked) {
      return getStaticMessage(StaticMessage.CanNotCopyIfLockedDpr);
    }

    if (!canCopy) {
      return getStaticMessage(StaticMessage.CanNotCopyIfDataTooltip);
    }

    if (!appOnline) {
      return getStaticMessage(StaticMessage.UnavailableInOfflineTooltip);
    }

    return null;
  }
}
